/**
 * Константы для формы создания/редактирования вакансии
 */

export const CITIES = [
  'Москва',
  'Санкт-Петербург',
  'Казань',
  'Омск',
  'Самара',
  'Уфа',
] as const;

export const CANDIDATE_STATUSES = [
  { value: 'actively_searching', label: 'Активно ищет работу' },
  { value: 'considering_offers', label: 'Рассматривает предложения' },
  { value: 'deciding', label: 'Предложили работу, решает' },
  { value: 'started_new_job', label: 'Вышел на новое место' },
  { value: 'not_searching', label: 'Не ищет работу' },
] as const;

export const EMPLOYMENT_TYPES = [
  { value: 'full_time_office', label: 'Полный день (офис)' },
  { value: 'remote', label: 'Удалённая работа' },
] as const;

export const EMPLOYMENT_CONTRACT_TYPES = [
  { value: 'tk_rf', label: 'По ТК' },
  { value: 'ip', label: 'ИП' },
  { value: 'self_employed', label: 'Самозанятый' },
  { value: 'individual', label: 'Физлицо (ГПХ)' },
  { value: 'accredited_it', label: 'Аккредитованная IT компания' },
] as const;

export const WORK_FORMATS = ['Офис', 'Гибрид', 'Удаленка'] as const;

export const WORK_SCHEDULES = [
  'Полный день',
  'Гибкий график',
  'Сменный график',
  'Вахтовый метод',
] as const;

export const GENDER_OPTIONS = [
  { value: 'any', label: 'Любой' },
  { value: 'male', label: 'М' },
  { value: 'female', label: 'Ж' },
] as const;

export const EXPERIENCE_OPTIONS = [
  'Нет опыта',
  'От 1 года до 3 лет',
  'От 3 до 6 лет',
  'Более 6 лет',
] as const;

export const EXPERIENCE_PERIOD_OPTIONS = [
  { value: 'all_time', label: 'За всё время опыта' },
  { value: 'last_year', label: 'За последний год' },
  { value: 'last_three_years', label: 'За последние 3 года' },
  { value: 'last_six_years', label: 'За последние 6 лет' },
] as const;

export const EDUCATION_OPTIONS = [
  { value: '', label: 'Выберите образование...' },
  { value: 'secondary', label: 'Среднее' },
  { value: 'special_secondary', label: 'Среднее специальное' },
  { value: 'unfinished_higher', label: 'Неоконченное высшее' },
  { value: 'higher', label: 'Высшее' },
  { value: 'bachelor', label: 'Бакалавр' },
  { value: 'master', label: 'Магистр' },
  { value: 'candidate', label: 'Кандидат наук' },
  { value: 'doctor', label: 'Доктор наук' },
] as const;
